import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import PilotsSection from './components/PilotsSection';
import PerformanceSection from './components/PerformanceSection';
import HowItWorksSection from './components/HowItWorksSection';
import CockpitClearanceSection from './components/CockpitClearanceSection';
import CockpitSection from './components/CockpitSection';
import GamificationSection from './components/GamificationSection';
import EarlyAccessSection from './components/EarlyAccessSection';
import FinalCTASection from './components/FinalCTASection';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import BackToTopButton from '../../components/feature/BackToTopButton';
import AnnouncementBanner from './components/AnnouncementBanner';
import ExitIntentPopup from '../../components/feature/ExitIntentPopup';
import SocialProofTicker from './components/SocialProofTicker';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);
  const [bannerVisible, setBannerVisible] = useState(true);
  const [showStickyBtn, setShowStickyBtn] = useState(false);
  const heroRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      // Show sticky button after scrolling past ~100vh (hero section height)
      setShowStickyBtn(window.scrollY > window.innerHeight * 0.85);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#0A1628] text-white">
      {bannerVisible && (
        <AnnouncementBanner onDismiss={() => setBannerVisible(false)} />
      )}
      <Navigation scrolled={scrolled} bannerVisible={bannerVisible} />
      <div ref={heroRef}>
        <HeroSection />
      </div>
      <SocialProofTicker />
      <PilotsSection />
      <PerformanceSection />
      <HowItWorksSection />
      <CockpitClearanceSection />
      <CockpitSection />
      <GamificationSection />
      <EarlyAccessSection />
      <FinalCTASection />
      <Footer />
      <BackToTopButton />
      <ExitIntentPopup />

      {/* Sticky Join Waitlist CTA */}
      <div
        className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-50 transition-all duration-500 ${
          showStickyBtn
            ? 'opacity-100 translate-y-0 pointer-events-auto'
            : 'opacity-0 translate-y-8 pointer-events-none'
        }`}
      >
        <button
          onClick={() => navigate('/waitlist')}
          className="flex items-center gap-3 bg-[#00FFD1] hover:bg-[#00e6bc] text-[#0A1628] font-bold px-8 py-3.5 rounded-full shadow-2xl shadow-[#00FFD1]/30 hover:shadow-[#00FFD1]/50 hover:scale-105 transition-all duration-200 cursor-pointer whitespace-nowrap text-sm tracking-wide"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-rocket-line text-base"></i>
          </span>
          Join the Waitlist — It's Free
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-right-line text-base"></i>
          </span>
        </button>
      </div>
    </div>
  );
}
